// The one place a run's finish becomes a number the board can rank.
//
// Sharp Mountain is a time trial. Food is a completion bonus, not a route
// decision: measured with bot riders across sixty seeds, a rider who detours
// for every pickup loses nothing against one who never does, because
// steering costs no speed and every pickup sits well inside the reach
// available between them. So the bonuses are deliberately small next to the
// things that actually separate riders -- roughly 50s from a novice to an
// expert on the same hill, and about 8s of hill-to-hill spread for one
// rider. Sweeping every pickup on the hill is worth about 5s. It rewards
// playing the whole game; it cannot leapfrog a faster descent.
//
// Everything here is integer milliseconds. The leaderboard stores time as a
// decimal with three places and ranks on the integer units behind it, so
// computing in ms keeps the client and the service agreeing to the unit.

export const HOT_DOG_BONUS_MS = 100;
export const BURGER_BONUS_MS = 300;

export type RunTally = {
  finishSeconds: number;
  hotDogs: number;
  burgers: number;
};

export function rawTimeMs(finishSeconds: number): number {
  return Math.round(finishSeconds * 1000);
}

export function foodBonusMs(hotDogs: number, burgers: number): number {
  return hotDogs * HOT_DOG_BONUS_MS + burgers * BURGER_BONUS_MS;
}

// The ranked value. Floors at zero rather than going negative, which cannot
// happen on the shipped hill but keeps the function total.
export function adjustedTimeMs(run: RunTally): number {
  return Math.max(0, rawTimeMs(run.finishSeconds) - foodBonusMs(run.hotDogs, run.burgers));
}
